import React from "react";
import { Check } from "lucide-react";
import { visibleSteps, STEP_LABELS, STEP_KEYS, type StepKey } from "@/lib/configurator";

interface Props {
  currentIndex: number;
  soloColori: boolean;
  onJump: (index: number) => void;
  completed: (key: StepKey) => boolean;
}

export const Stepper: React.FC<Props> = ({ currentIndex, soloColori, onJump, completed }) => {
  const steps = visibleSteps(soloColori);
  const currentKey = STEP_KEYS[currentIndex];

  return (
    <div className="flex flex-col gap-1" data-testid="configurator-stepper">
      {steps.map((key) => {
        const idx = STEP_KEYS.indexOf(key);
        const isActive = key === currentKey;
        const done = completed(key) && !isActive;
        return (
          <button
            key={key}
            data-testid={`stepper-${key}`}
            onClick={() => done && onJump(idx)}
            disabled={!done && !isActive}
            className={`group flex items-center gap-3 px-4 py-2.5 text-left border-l-2 transition-colors ${
              isActive
                ? "border-primary text-foreground"
                : done
                ? "border-secondary/60 text-muted-foreground hover:text-secondary"
                : "border-white/10 text-muted-foreground/40"
            }`}
          >
            <span className={`flex h-6 w-6 shrink-0 items-center justify-center text-[11px] font-bold ${
              isActive ? "bg-primary text-primary-foreground" : done ? "bg-secondary text-black" : "bg-white/10"
            }`}>
              {done ? <Check className="h-3.5 w-3.5" /> : steps.indexOf(key) + 1}
            </span>
            <span className="text-sm font-medium uppercase tracking-wider">{STEP_LABELS[key]}</span>
          </button>
        );
      })}
    </div>
  );
};
